import { isValidLatitude, isValidLongitude, MaterialIcon } from '@gorila-shared-ui/components';
import { memo } from 'react';
import { Marker } from 'react-map-gl/mapbox';
import { StyledTooltip } from '../../ui/StyledTooltip';

type Props = {
  lng: number;
  lat: number;
  label: string;
};
function LiveStatusMarker({ lng, lat, label }: Readonly<Props>) {
  if (!lat || !lng) return null;

  const point = {
    lng,
    lat,
  };
  const isValidPoint = isValidLatitude(point.lat) && isValidLongitude(point.lng);

  if (!isValidPoint) return null;

  return (
    <Marker
      latitude={point.lat}
      longitude={point.lng}
    >
      <StyledTooltip content={label}>
        <MaterialIcon name={'place'} />
      </StyledTooltip>
    </Marker>
  );
}

export default memo(LiveStatusMarker);
